import { createContext } from "react";
import _noop from "lodash/noop";

export const ShowBulkUploadSubmittalsContext = createContext({
  showBulkUploadSubmittals: false,
  setShowBulkUploadSubmittals: _noop,
});
